export default {
    page_title: "Kevi | General Report",
    title: "General Report",
    stats: {
        clients: "Clients",
        orders: "Orders",
        total_income: "Total revenue",
        avg_ticket: "Average ticket",
        avg_time_between_orders: "Average time between orders",
        incentivized_income: "Incentivized revenue",
        base_clients: "Existing Clients ({0}%)",
        days_suffix: "days",
    },
    pie_chart: {
        first_time: "First Time",
        returned: "Returned",
    },
    downloads: {
        orders_aria_label: "Download file with order data",
        orders_tooltip: "Download orders",
        incentivized_orders_aria_label:
            "Download file with incentivized order data",
        incentivized_orders_tooltip: "Download incentivized orders",
    },
    filters: {
        first_order_period: "First order period",
        client_segments: "Client segment",
        order_status: "Order status",
    },
    states: {
        empty: "There is not enough data for the selected period",
    },
    charts: {
        orders_and_income_by: "Orders and Revenue by",
        average_by: "Average by",
        retention_curve: "Retention Curve",
        income_by_field: "Revenue by {0}",
        group_by: "Group by:",
    },
    chart_axes: {
        orders: "Orders",
        income: "Revenue",
        client_percentage: "% of Clients",
        orders_in_period: "Orders in the period",
    },
    tooltips: {
        clients_percentage: "{0}% ({1} clients)",
        not_informed: "Not informed",
    },
};
